import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      name: "PageView",
      component: (resolve) => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home",
        },
        {
          path: "/home",
          name: "home",
          component: (resolve) => require(["@/view/home/HomePage"], resolve),
          meta: {
            title: "首页",
          },
        },
        {
          path: "/home/Software",
          name: "homeIndex",
          component: (resolve) => require(["@/view/home/Software"], resolve),
          meta: {
            title: "首页",
          },
          children: [
            {
              path: "/home/Software",
              redirect: "/home/ContactUs",
              meta: {
                title: "首页",
              },
            },
            {
              path: "/home/ContactUs",
              name: "homeInfo",
              component: (resolve) =>
                require(["@/view/home/ContactUs"], resolve),
              meta: {
                title: "首页",
              },
            },
            {
              path: "/home/introduce",
              name: "homeList",
              component: (resolve) =>
                require(["@/view/home/introduce"], resolve),
              meta: {
                title: "首页",
              },
            },
            {
              path: "/home/introduceDetail",
              name: "homeDetail",
              component: (resolve) =>
                require(["@/view/home/introduceDetail"], resolve),
              meta: {
                title: "首页",
              },
            },
          ],
        },
        {
          path: "/alumniAssociation",
          name: "alumniAssociation",
          component: (resolve) =>
            require(["@/view/alumniAssociation/Software"], resolve),
          meta: {
            title: "关于校友会",
          },
          children: [
            {
              path: "/alumniAssociation",
              redirect: "/alumniAssociation/info",
            },
            {
              path: "/alumniAssociation/info",
              component: (resolve) =>
                require(["@/view/alumniAssociation/info"], resolve),
              meta: {
                title: "关于校友会",
              },
            },
            {
              path: "/alumniAssociation/introduce",
              component: (resolve) =>
                require(["@/view/alumniAssociation/introduce"], resolve),
              meta: {
                title: "关于校友会",
              },
            },
            {
              path: "/alumniAssociation/introduceDetail",
              component: (resolve) =>
                require(["@/view/alumniAssociation/introduceDetail"], resolve),
              meta: {
                title: "关于校友会",
              },
            },
            {
              path: "/alumniAssociation/organizationStructure",
              component: (resolve) =>
                require([
                  "@/view/alumniAssociation/organizationStructure",
                ], resolve),
              meta: {
                title: "组织结构",
              },
            },
            {
              path: "/alumniAssociation/ContactUs",
              component: (resolve) =>
                require(["@/view/alumniAssociation/ContactUs"], resolve),
              meta: {
                title: "联系方式",
              },
            },
          ],
        },
        {
          path: "/service",
          component: (resolve) => require(["@/view/Service"], resolve),
          meta: {
            title: "相关服务",
          },
        },
        {
          path: "/newsinformation",
          component: (resolve) => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: "新闻动态",
          },
        },
        {
          path: "/companyintroduction",
          component: (resolve) =>
            require(["@/view/CompanyIntroduction"], resolve),
          meta: {
            title: "公司介绍",
          },
        },
        {
          path: "/jobchance",
          component: (resolve) => require(["@/view/JobChance"], resolve),
          meta: {
            title: "工作机会",
          },
        },
        {
          path: "/servicedetail",
          component: (resolve) => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: "相关服务",
          },
        },
        {
          path: "/message",
          component: (resolve) => require(["@/view/message/Software"], resolve),
          meta: {
            title: "留言咨询",
          },
          children: [
            {
              path: "/message",
              redirect: "/message/ContactUs",
            },
            {
              path: "/message/list",
              component: (resolve) => require(["@/view/message/list"], resolve),
              meta: {
                title: "留言内容",
              },
            },
            {
              path: "/message/ContactUs",
              component: (resolve) =>
                require(["@/view/message/ContactUs"], resolve),
              meta: {
                title: "留言板",
              },
            },
          ],
        },
        {
          path: "/resourceCentre",
          component: (resolve) =>
            require(["@/view/resourceCentre/Software"], resolve),
          meta: {
            title: "资源中心",
          },
          children: [
            {
              path: "/resourceCentre",
              redirect: "/resourceCentre/ContactUs",
            },
            {
              path: "/resourceCentre/introduce",
              component: (resolve) =>
                require(["@/view/resourceCentre/introduce"], resolve),
              meta: {
                title: "资料下载",
              },
            },
            {
              path: "/resourceCentre/introduceDetail",
              component: (resolve) =>
                require(["@/view/resourceCentre/introduceDetail"], resolve),
              meta: {
                title: "",
              },
            },
            {
              path: "/resourceCentre/ContactUs",
              component: (resolve) =>
                require(["@/view/resourceCentre/ContactUs"], resolve),
              meta: {
                title: "校园风光",
              },
            },
          ],
        },
        {
          path: "/search",
          component: (resolve) => require(["@/view/search"], resolve),
          meta: {
            title: "检索结果",
          },
        },
        {
          path: "/search/Software",
          component: (resolve) => require(["@/view/search/Software"], resolve),
          meta: {
            title: "检索结果",
          },
          children: [
            {
              path: "/home/Software",
              redirect: "/home/introduceDetail",
              meta: {
                title: "检索结果",
              },
            },
            {
              path: "/search/introduceDetail",
              component: (resolve) =>
                require(["@/view/search/introduceDetail"], resolve),
              meta: {
                title: "检索结果",
              },
            },
          ],
        },
        {
          path: "/branchConstruction",
          component: (resolve) =>
            require(["@/view/branchConstruction/Software"], resolve),
          meta: {
            title: "分会建设",
          },
          children: [
            {
              path: "/branchConstruction",
              redirect: "/branchConstruction/ContactUs",
              meta: {
                title: "分会建设",
              },
            },
            {
              path: "/branchConstruction/ContactUs",
              component: (resolve) =>
                require(["@/view/branchConstruction/ContactUs"], resolve),
              meta: {
                title: "分会建设",
              },
            },
            {
              path: "/branchConstruction/introduce",
              component: (resolve) =>
                require(["@/view/branchConstruction/introduce"], resolve),
              meta: {
                title: "分会新闻",
              },
            },
            {
              path: "/branchConstruction/introduceDetail",
              component: (resolve) =>
                require(["@/view/branchConstruction/introduceDetail"], resolve),
              meta: {
                title: "",
              },
            },
          ],
        },
        {
          path: "/alumniStories",
          component: (resolve) =>
            require(["@/view/alumniStories/Software"], resolve),
          meta: {
            title: "校友故事",
          },
          children: [
            {
              path: "/alumniStories",
              redirect: "/alumniStories/info",
            },
            {
              path: "/alumniStories/info",
              component: (resolve) =>
                require(["@/view/alumniStories/info"], resolve),
              meta: {
                title: "校友故事",
              },
            },
            {
              path: "/alumniStories/introduce",
              component: (resolve) =>
                require(["@/view/alumniStories/introduce"], resolve),
              meta: {
                title: "校友故事",
              },
            },
            {
              path: "/alumniStories/introduceDetail",
              component: (resolve) =>
                require(["@/view/alumniStories/introduceDetail"], resolve),
              meta: {
                title: "",
              },
            },
            {
              path: "/alumniStories/ContactUs",
              component: (resolve) =>
                require(["@/view/alumniStories/ContactUs"], resolve),
              meta: {
                title: "校园风光",
              },
            },
          ],
        },
        {
          path: "/notice",
          component: (resolve) => require(["@/view/notice/Software"], resolve),
          meta: {
            title: "通知公告",
          },
          children: [
            {
              path: "/notice",
              redirect: "/notice/introduce",
              meta: {
                title: "通知公告",
              },
            },
             {
              path: "/notice/introduce",
              component: (resolve) =>
                require(["@/view/notice/introduce"], resolve),
              meta: {
                title: "通知公告",
              },
            },
            {
              path: "/notice/list",
              component: (resolve) =>
                require(["@/view/notice/list"], resolve),
              meta: {
                title: "光荣榜",
              },
            },
            {
              path: "/notice/info",
              component: (resolve) =>
                require(["@/view/notice/info"], resolve),
              meta: {
                title: "荣誉墙",
              },
            },
            {
              path: "/notice/introduceDetail",
              component: (resolve) =>
                require(["@/view/notice/introduceDetail"], resolve),
              meta: {
                title: "",
              },
            },
          ],
        },
        {
          path: "/partyBuilding",
          component: (resolve) =>
            require(["@/view/partyBuilding/Software"], resolve),
          meta: {
            title: "党建领航",
          },
          children: [
            {
              path: "/partyBuilding",
              redirect: "/partyBuilding/introduce",
              meta: {
                title: "党建领航",
              },
            },
            
            {
              path: "/partyBuilding/introduce",
              component: (resolve) =>
                require(["@/view/partyBuilding/introduce"], resolve),
              meta: {
                title: "党建领航",
              },
            },
            {
              path: "/partyBuilding/introduceDetail",
              component: (resolve) =>
                require(["@/view/partyBuilding/introduceDetail"], resolve),
              meta: {
                title: "",
              },
            },
          ],
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js